import axios from "axios";
import { useState } from "react";
import { IoIosArrowDown } from "react-icons/all";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

const dateRangeConfig = [
  {
    from: { date: "11-24-2021", time: "12:30" },
    to: { date: "01-04-2022", time: "16:00" },
  },
];

const AppointmentForm = () => {
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState("");
  const [note, setNote] = useState("");

  const [startDate, setStartDate] = useState();
  const [time, setTime] = useState();

  console.log(time);

  const filterDate = (date) => {
    const dateRange = dateRangeConfig.filter((range) => {
      const from = new Date(range.from.date);
      const to = new Date(range.to.date);
      return date >= from && date <= to;
    });
    return dateRange.length > 0;
  };

  const filterTimeBasedOnStartDate = (time) => {
    const dateRange = dateRangeConfig.filter((range) => {
      const from = new Date(range.from.date);
      const to = new Date(range.to.date);
      return startDate >= from && startDate <= to;
    });

    for (let i = 0; i < dateRange.length; i++) {
      const range = dateRange[i];
      const from = new Date(range.from.date);
      const to = new Date(range.to.date);

      if (from.getTime() === startDate?.getTime()) {
        const fromTime = new Date();
        fromTime.setHours(range.from.time.split(":")[0]);
        fromTime.setMinutes(range.from.time.split(":")[1]);
        return time >= fromTime && time <= new Date().setHours(17);
      } else if (to.getTime() === startDate?.getTime()) {
        const toTime = new Date();
        toTime.setHours(range.to.time.split(":")[0]);
        toTime.setMinutes(range.to.time.split(":")[1]);
        return time >= new Date().setHours(9) && time <= toTime;
      } else {
        return (
          time > new Date().setHours(8,30) && time <= new Date().setHours(16,30)
        );
      }
    }
    return false;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForms({
      ...forms,
      [name]: value,
    });
  };

  const bookAppointment = async (e) => {
    e.preventDefault();
    const payload = {
      full_name: forms.full_name,
      email_address: forms.email_address,
      phone_number: forms.phone_number,
      appointment_date: startDate.toLocaleDateString(),
      time: time.toLocaleTimeString(),
      note: note,
    };

    setLoading(true);
    await axios({
      method: "POST",
      url: "https://heritagemensclinic.ng/api/consult/sc-appointment.php",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: payload,
    })
      .then((res) => {
        if (res.data.status === true) {
          window.location.replace("/thank-you.html");
        } else {
          console.log(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    setLoading(false);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  return (
    <div className="w-full">
      <p id="appointment" className="font-Airbnb font-bold lg:text-title text-title_mobile lg:px-4">
        Make an Appointment
        <span className="font-sora text-sm"> &#8212;&#8212;&#8212;</span>{" "}
      </p>
      <p className="font-Airbnb opacity-70 py-3 hidden lg:block lg:px-4">
        Take the first step to living a life free of consistent sickle cell
        <br />
        disease crisis, book an appointment today.
      </p>
      <p className="font-Airbnb py-5 text-xs lg:hidden lg:px-4 opacity-70">
        Take the first step to living a life free of consistent sickle cell
        disease crisis, book an appointment today.
      </p>
      <form className="w-full font-bold">
        <div className="flex flex-wrap mb-6">
          {formData.map((data, i) =>
            data.name === "full_name" || data.name === "phone_number" ? (
              <div
                className="w-full lg:w-1/2  mb-6 md:mb-0 lg:mb-6 lg:px-4"
                key={i}
              >
                <label className="block font-Airbnb tracking-wide text-gray-700 lg:text-label text-offer-text font-bold mb-2">
                  {data.label}
                </label>
                <input
                  className="appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  type={data.type}
                  name={data.name}
                  value={
                    data.name === "full_name"
                      ? forms.full_name
                      : forms.phone_number
                  }
                  onChange={handleChange}
                />
              </div>
            ) : data.name === "email_address" ? (
              <div className="w-full  mb-6 md:mb-0 lg:mb-6 lg:px-4" key={i}>
                <label className="block font-Airbnb tracking-wide text-gray-700 text-label font-bold mb-2">
                  {data.label}
                </label>

                <input
                  className="appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  type={data.type}
                  name={data.name}
                  value={
                    data.name === "email_address" ? forms.email_address : ""
                  }
                  onChange={handleChange}
                />
              </div>
            ) : data.name === "appointment_date" || "time" ? (
              <div
                className="w-full lg:w-1/2  mb-6 md:mb-0 lg:mb-6 lg:px-4 relative"
                key={i}
              >
                <label className="block font-Airbnb tracking-wide text-gray-700 text-label font-bold mb-2">
                  {data.label}
                </label>
                <IoIosArrowDown
                  className="pointer-events-none w-5 h-8 transform -translate-y-1/2  z-10"
                  style={{ position: "absolute", top: "70%", right: "30px" }}
                />
                {data.name === "appointment_date" ? (
                  <DatePicker
                    className="appearance-none block w-full p-2 bg-gray-50 text-gray-700 border border-gray-200 rounded  h-12 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    placeholderText="Select an option"
                    selected={startDate}
                    filterDate={filterDate}
                    dateFormat="dd/MM/yyyy"
                    onChange={handleDateChange}
                    disabledKeyboardNavigation
                  />
                ) : data.name === "time" ? (
                  <DatePicker
                    selected={time}
                    className="appearance-none block w-full p-2 bg-gray-50 text-gray-700 border border-gray-200 rounded  h-12 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    onChange={(date) => setTime(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    placeholderText="Select an option"
                    filterTime={filterTimeBasedOnStartDate}
                    timeIntervals={30}
                    timeCaption="Time"
                    dateFormat="HH:mm"
                  />
                ) : (
                  <input
                    className="appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded  h-12 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type={data.type}
                    name={data.name}
                    placeholder="Select an option"
                    onFocus={
                      data.name === "appointment_date"
                        ? (e) => (e.currentTarget.type = "date")
                        : ""
                    }
                    onBlur={(e) => (e.currentTarget.type = "text")}
                    value={
                      data.name === "appointment_date"
                        ? forms.appointment_date
                        : forms.time
                    }
                    onChange={handleChange}
                  />
                )}
              </div>
            ) : (
              ""
            )
          )}
          <div className="w-full  mb-6 md:mb-0 lg:mb-6 lg:px-4">
            <div>
              <div className="w-full mb-5">
                <label className="block font-Airbnb tracking-wide text-gray-700 text-label font-bold mb-2">
                  Leave a Note <span className="font-Airbnb">(Optional)</span>
                </label>
                <textarea
                  className="appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-8 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  name="note"
                  onChange={(e) => setNote(e.target.value)}
                ></textarea>
              </div>
            </div>
            <button
              className="w-full  h-12 bg-primary hover:bg-green-700 disabled:bg-gray-200 disabled:cursor-not-allowed text-white font-Airbnb text-xl rounded-md"
              disabled={
                !forms.full_name || !forms.email_address || !forms.phone_number
              }
              type="submit"
              onClick={bookAppointment}
            >
              {loading ? (
                <div className="flex justify-center">
                  <svg
                    className="animate-spin mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AppointmentForm;

const formData = [
  {
    name: "full_name",
    label: "Full name",
    type: "text",
  },
  {
    name: "phone_number",
    label: "Phone number",
    type: "tel",
  },
  {
    name: "email_address",
    label: "Email address",
    type: "email",
  },
  {
    name: "appointment_date",
    label: "Appointment Date",
    type: "date",
  },
  {
    name: "time",
    label: "Time",
    type: "time",
  },
];
